import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { sessionVerificationQueryOptions } from "@/app/user-verification/api/get-session-verification";
import { UserVerificationSkeleton } from "@/app/user-verification/components";
import { UserVerification } from "@/app/user-verification/list";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification"
)({
  component: () => (
    <Suspense fallback={<UserVerificationSkeleton />}>
      <UserVerification />
    </Suspense>
  ),
  beforeLoad: (ctx) => {
    ctx.context.queryClient.prefetchQuery(
      sessionVerificationQueryOptions({ binding: "project", scope: ctx.params })
    );
  },
  loader: () => ({
    crumb: "User Verification",
  }),
});
